import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonVi from './vi/common.json';
import commonEn from './en/common.json';
import commonJa from './ja/common.json';
import commonKo from './ko/common.json';
import commonZh from './zh/common.json';

import dashboardVi from './vi/dashboard.json';
import dashboardEn from './en/dashboard.json';
import dashboardJa from './ja/dashboard.json';
import dashboardKo from './ko/dashboard.json';
import dashboardZh from './zh/dashboard.json';

import conversationVi from './vi/conversation.json';
import conversationEn from './en/conversation.json';
import conversationJa from './ja/conversation.json';
import conversationKo from './ko/conversation.json';
import conversationZh from './zh/conversation.json';

import knowledgeVi from './vi/knowledge.json';
import knowledgeEn from './en/knowledge.json';
import knowledgeJa from './ja/knowledge.json';
import knowledgeKo from './ko/knowledge.json';
import knowledgeZh from './zh/knowledge.json';

import scenariosVi from './vi/scenarios.json';
import scenariosEn from './en/scenarios.json';
import scenariosJa from './ja/scenarios.json';
import scenariosKo from './ko/scenarios.json';
import scenariosZh from './zh/scenarios.json';

import accountVi from './vi/account.json';
import accountEn from './en/account.json';
import accountJa from './ja/account.json';
import accountKo from './ko/account.json';
import accountZh from './zh/account.json';

import chatbotVi from './vi/chatbot.json';
import chatbotEn from './en/chatbot.json';
import chatbotJa from './ja/chatbot.json';
import chatbotKo from './ko/chatbot.json';
import chatbotZh from './zh/chatbot.json';

import authVi from './vi/auth.json';
import authEn from './en/auth.json';
import authJa from './ja/auth.json';
import authKo from './ko/auth.json';
import authZh from './zh/auth.json';

// Default locale: read from localStorage (synced from biztada-app shell)
const STORAGE_KEY = 'biztada-language';
function loadLocale(): string {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && ['vi', 'en', 'ja', 'ko', 'zh'].includes(saved)) return saved;
  } catch {}
  return 'vi';
}

i18n.use(initReactI18next).init({
  resources: {
    vi: {
      common: commonVi,
      dashboard: dashboardVi,
      conversation: conversationVi,
      knowledge: knowledgeVi,
      scenarios: scenariosVi,
      account: accountVi,
      chatbot: chatbotVi,
      auth: authVi,
    },
    en: {
      common: commonEn,
      dashboard: dashboardEn,
      conversation: conversationEn,
      knowledge: knowledgeEn,
      scenarios: scenariosEn,
      account: accountEn,
      chatbot: chatbotEn,
      auth: authEn,
    },
    ja: {
      common: commonJa,
      dashboard: dashboardJa,
      conversation: conversationJa,
      knowledge: knowledgeJa,
      scenarios: scenariosJa,
      account: accountJa,
      chatbot: chatbotJa,
      auth: authJa,
    },
    ko: {
      common: commonKo,
      dashboard: dashboardKo,
      conversation: conversationKo,
      knowledge: knowledgeKo,
      scenarios: scenariosKo,
      account: accountKo,
      chatbot: chatbotKo,
      auth: authKo,
    },
    zh: {
      common: commonZh,
      dashboard: dashboardZh,
      conversation: conversationZh,
      knowledge: knowledgeZh,
      scenarios: scenariosZh,
      account: accountZh,
      chatbot: chatbotZh,
      auth: authZh,
    },
  },
  lng: loadLocale(),
  fallbackLng: 'vi',
  defaultNS: 'common',
  ns: ['common', 'dashboard', 'conversation', 'knowledge', 'scenarios', 'account', 'chatbot', 'auth'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
